// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_s-0";
export var colorSwatch = "_s-5";
export var compactSwatch = "_s-7";
export var fillWidth = "_s-4";
export var iconButton = "_s-2";
export var iconWrapper = "_s-3";
export var shadow = "_s-6";
export var xs = "_s-1";